export default "__VITE_ASSET__791d8dc5__"